import React, { useEffect, Component, useState } from 'react'
import { Link } from 'react-router-dom'
import history from '../../route/history'
import PrivacyMaster from './PrivacyMaster'
import moment from 'moment'

const Privacy = (props) => {
   const [select, setSelect] = useState('')
   const [privacyPage, setPrivacyPage] = useState(true)
   const [priOption, setPriOtion] = useState(props?.privacy?.data?.ptlTerms)
   const [options, setOptions] = useState(props?.privacy?.data?.trmsHit)

   const optionSettings = (aList) => {
     setOptions(aList)
   }

   const priOptionSetting = (data) => {
     setPriOtion(data)
   }

   const handleChange = (e) => {
     const { value } = e.target
     setSelect(value)
   }

  const prePage = (e) => {
    e.preventDefault()
    history.goBack()
  }

  //   useEffect(() => {
  //     console.log(options)
  // }, [options])
      return (
        <React.Fragment>
           <div className="content">
            <div id="contents">
              <div className="content-header">
                <a href="#" onClick={prePage} className="page-prev">뒤로이동</a>{/* <!-- mobile --> */}
                <h2>개인정보처리방침</h2>
                <div className="breadcrumb">
                  <span>Home</span><span>고객센터</span><em>개인정보처리방침</em>
                </div>
              </div>
              <section>
                 <div className="policy-box">
                   <div className="policy-header">
                     <div></div>
                     <select className="form-category" onChange={handleChange}>
{/*                        <option value={''} style={{ textAlign: 'center' }}> */}
{/*                          {priOption?.trmsTtl} */}
{/*                        </option> */}
{/*                        {options?.map((option) => ( */}
{/*                          <option value={option?.trmsSeq} key={option.trmsSeq} style={{ textAlign: 'center' }}> */}
{/*                            {option?.trmsTtl} */}
{/*                          </option> */}
{/*                        ))} */}
{/*                      <option value={""} style={{textAlign: "center"}}>{moment(priOption?.regDt).format('YYYY년 MM월 DD일 개정')}</option> */}
                          {options?.map((option) => (
                            <option value={option?.trmsSeq} key={option.trmsSeq} style={{textAlign: "center"}}>{moment(option?.regDt).format('YYYY년 MM월 DD일 제정')}</option>
                          ))}
                     </select>
                   </div>
                   <PrivacyMaster
                     select={select}
                     privacyPage={privacyPage}
                     optionSettings={optionSettings}
                     priOptionSetting={priOptionSetting}
                   />
                 </div>
    {/*            <PrivacyMaster /> */}
              </section>
            </div>
           </div>
        </React.Fragment>
      )
}

export default Privacy
